// extracted by mini-css-extract-plugin
export var arrow = "resultItem-module--arrow--6fe21";
export var bronze = "resultItem-module--bronze--f0e33";
export var company = "resultItem-module--company--ec401";
export var gold = "resultItem-module--gold--6b908";
export var image = "resultItem-module--image--359e5";
export var isNew = "resultItem-module--isNew--6aabc";
export var logo = "resultItem-module--logo--f0a31";
export var movesUp = "resultItem-module--movesUp--04e78";
export var points = "resultItem-module--points--28f42";
export var pts = "resultItem-module--pts--ea7de";
export var rank = "resultItem-module--rank--3614d";
export var ranking = "resultItem-module--ranking--62d4a";
export var resultItem = "resultItem-module--resultItem--dae22";
export var silver = "resultItem-module--silver--3cc0e";
export var transparent = "resultItem-module--transparent--378c9";